var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{staticClass:"offer-stat d-flex flex-column pa-0",attrs:{"cols":"5","sm":"4","md":"3"}},[_c('h4',{staticClass:"offer-stat__title ma-0",class:{
      'offer-stat--disabled': _vm.disabled
    }},[_vm._v(_vm._s(_vm.title))]),_c('v-spacer'),_c('p',{staticClass:"offer-stat__number ma-0",class:{
      'offer-stat--disabled': _vm.disabled
    }},[_vm._v(" "+_vm._s(_vm.number)+" ")]),_c('v-spacer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }